"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var user_geoservice_1 = require("ayvri-services/lib/user-geoservice");
var preconditions_ts_1 = require("preconditions-ts");
var env_1 = require("../../helpers/env");
var scene_1 = require("../../helpers/scene");
var user_geo_1 = require("../user-geo");
// tslint:disable-next-line:no-var-requires
var styles = require('./embed.css');
window.addEventListener('DOMContentLoaded', function () { return runPlayer(); });
var unitPromise = (function () {
    var urlParams = new URLSearchParams(window.location.search);
    var units = urlParams.get('units');
    return user_geoservice_1.isUnits(units) ? Promise.resolve(units) : user_geo_1.userGeo().getUnits();
})();
function runPlayer() {
    var viewer = preconditions_ts_1.required(window.AyvriViewer, 'viewer not loaded');
    var viewerContainer = preconditions_ts_1.required(document.getElementById('player'), 'unable to player the html element to hold the player');
    var scene = scene_1.toPlayerScene(window.sceneJson);
    var globeOptions = !!window.features.ayvri_globe_enabled
        ? { enableAyvriGlobe: true, enableCesiumGlobe: false }
        : {};
    var options = __assign({ features: window.features, isEmbed: true }, globeOptions);
    viewer.initialize(viewerContainer, env_1.env().viewerAssetPath(), scene, options).then(function () {
        unitPromise.then(function (units) { return viewer.setUnits({ units: units }); });
    });
    var redirectAnchor = window.document.getElementById('clientRedirectAnchor');
    if (redirectAnchor) {
        redirectAnchor.addEventListener('click', function (evt) { return evt.stopPropagation(); });
    }
}
